export default {
  path: '/material_manufacturers',
  name: 'material_manufacturers',
  component: () => import('../components/materialmanufacturer/Layout'),
  redirect: { name: 'MaterialManufacturerList' },
  meta: {
    breadcrumb: 'profile.material.manufacturers',
  },
  children: [
    {
      name: 'MaterialManufacturerList',
      path: '',
      component: () => import('../views/materialmanufacturer/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MaterialManufacturerCreate',
      path: 'new',
      component: () => import('../views/materialmanufacturer/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MaterialManufacturerUpdate',
      path: ':id/edit',
      component: () => import('../views/materialmanufacturer/Update'),
      meta: {
        breadcrumb: 'profile.material.manufacturer',
      },
    },
    {
      name: 'MaterialManufacturerShow',
      path: ':id',
      component: () => import('../views/materialmanufacturer/Show'),
      meta: {
        breadcrumb: 'profile.material.manufacturer',
      },
    }
  ]
};
